export default __webpack_public_path__ + "f8ceea5a0ca8a33436a30845a6478605.png";